import { SET_REGIONS, CLEAR_REGIONS } from '../actions/actionTypes';
import { ReceiverRegionAction } from '../actions/receiver.regions';
import * as Regions from '../api/receiver';

const intialState: Regions.INrcRegion[] = [];

export type ReceiverRegionState = {
    regions: Regions.INrcRegion[];
};

const RECEIVER_REGIONS = (state = intialState, action: ReceiverRegionAction): Regions.INrcRegion[] => {
    switch (action.type) {
        case SET_REGIONS:
            return [...state, ...action.payload];
        case CLEAR_REGIONS:
            return intialState;
        default:
            return state;
    }
};

export default RECEIVER_REGIONS;
